<template>
  <div>
    <v-dialog persistent v-model="dialogAward" width="594">
      <div class="custom-dialog-award">
        <div class="item-award">
          <img :src="item.image" alt="" />
          <div class="title-success">Nhận quà thành công</div>
          <div class="text-content">
            Chúc mừng bạn vừa nhận được ưu đãi "{{ item.name }} "
          </div>
          <div class="button-bottom">
            <button class="outline" @click="$emit('closeDialog')">
              Để Sau
            </button>
            <button class="main" @click="$emit('closeDialog')">
              Dùng Ngay
            </button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dialogAward: true,
    };
  },
};
</script>

<style lang="scss">
.custom-dialog-award {
  width: 100%;
  background-image: url("../../../../assets/Board.jpg");
  .item-award {
    padding: 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    img {
      border-radius: 5px;
      width: 100%;
      aspect-ratio: 16/9;
    }
    .title-success {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-size: 32px;
      line-height: 140%;
      text-align: center;
      background: linear-gradient(90deg, #3ac882 0%, #97e98a 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .text-content {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      text-align: center;
      color: #cccccc;
    }
    .button-bottom {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      column-gap: 10px;
      justify-content: space-between;
      width: 100%;
      .outline {
        width: 50%;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 140%;
        background: linear-gradient(90deg, #3ac882 0%, #97e98a 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        border: 1px solid #3ac882;
        border-radius: 2px;
      }
      .main {
        width: 50%;
        padding: 7px 12px;
        gap: 10px;
        height: 36px;
        background: linear-gradient(90deg, #3ac882 0%, #97e98a 100%);
        border-radius: 2px;
      }
    }
  }
}
</style>
